import { registerLocaleData } from '@angular/common';
import localeSl from '@angular/common/locales/sl';
import { environment } from '../environments/environment';
registerLocaleData(localeSl, 'sl');
const ɵ0 = environment.baseUrl;
export class AppModule {
}
export { ɵ0 };
